"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUnit = void 0;
var pixi_js_1 = require("pixi.js");
var rxjs_1 = require("rxjs");
var app_1 = require("../../app");
var Health_1 = require("../Health");
var Colliders_1 = require("../Colliders");
var Attack_1 = require("../Attack");
var units_1 = require("../../data/units");
var Drops_1 = require("../Drops");
var Projectile_1 = require("../Projectile");
var createUnit = function (id, unitName, position) {
    var _unitData = units_1.units[unitName];
    if (!_unitData) {
        console.error("".concat(unitName, " is not a valid unit."));
        return;
    }
    var gameTicks$ = app_1.appService.gameTicks$, spriteContainer = app_1.appService.spriteContainer, UIContainer = app_1.appService.UIContainer;
    var _stats = _unitData.stats;
    var _dropTable = _unitData.dropTable || {};
    var _statOverrides = {};
    var _isRanged = _unitData.ranged;
    var _targetTypes = null; // array of possible target types (not being used yet)
    var _target = null; // unit or null
    var _canAttack = _stats.maxHit > 0; // always false if there is no max hit
    var _attackers = 0;
    var _itemsHeld = [];
    var getStats = function () { return (__assign(__assign({}, _stats), _statOverrides)); };
    var level = 0;
    // configure sprite
    var sprite = null;
    sprite = pixi_js_1.Sprite.from(_unitData.url);
    sprite.width = _unitData.width;
    sprite.height = _unitData.height;
    sprite.anchor.set(0.5);
    sprite.position.set(position.x, position.y);
    sprite.vx = 0;
    sprite.vy = 0;
    sprite.id = id; // is this dumb?
    spriteContainer.addChild(sprite);
    var health = (0, Health_1.Health)({ maxHP: getStats().maxHP, sprite: sprite, hideHealthBar: _unitData.hideUI, type: _unitData.type });
    health.subscribeToDeath(function () {
        (0, Drops_1.spawnDrops)(sprite, _dropTable);
    });
    if (getStats().HPregeneration > 0) {
        gameTicks$.subscribe(function () {
            health.heal(getStats().HPregeneration);
        });
    }
    var checkForStat = function (stat) {
        if (!_stats.hasOwnProperty(stat)) {
            console.error("Invalid stat: ".concat(stat));
            return false;
        }
        return true;
    };
    // TODO: all of these modify the original reference, when we want to be able to modify stats at the unit level we will need to change these to modify the "_statOverrides" property and move these functions out of each unit
    var setStat = function (stat, value) {
        if (!checkForStat(stat))
            return;
        _statOverrides[stat] = value;
    };
    var addToStat = function (stat, value) {
        if (!checkForStat(stat)) {
            console.error("".concat(stat, " not found."));
            return;
        }
        var newValue = (_statOverrides[stat] || _stats[stat]) + value;
        _statOverrides[stat] = Math.round(newValue * 100) / 100;
    };
    // finds the closest available target or returns null if none found
    // run every tick?
    var assignClosestTarget = function (type) {
        if (!_targetTypes) {
            console.error("No target type set.");
            return;
        }
        // search game state for targetType... assign closest potential target to _target
    };
    var attackTicks = null;
    var setTarget = function (target) {
        if ((_target === null || _target === void 0 ? void 0 : _target.id) === target.id)
            return;
        _target = target;
        attackTicks === null || attackTicks === void 0 ? void 0 : attackTicks.complete();
        attackTicks = gameTicks$.subscribe(function () { return tryAttack(); });
    };
    var clearTarget = function () {
        attackTicks === null || attackTicks === void 0 ? void 0 : attackTicks.complete();
        _target = null;
        attackTicks = null;
        line.clear();
    };
    health.subscribeToDeath(function () { return clearTarget(); });
    var line = new pixi_js_1.Graphics();
    UIContainer.addChild(line);
    var tryAttack = function () {
        var _a, _b;
        // check if can attack and target is set
        line.clear();
        if (app_1.gameState.debugMode) {
            line.lineStyle({ width: 2, color: _canAttack ? 0xffff55 : 0xff5555 });
            line.moveTo(sprite === null || sprite === void 0 ? void 0 : sprite.x, sprite === null || sprite === void 0 ? void 0 : sprite.y);
            line.lineTo((_a = _target === null || _target === void 0 ? void 0 : _target.sprite) === null || _a === void 0 ? void 0 : _a.x, (_b = _target === null || _target === void 0 ? void 0 : _target.sprite) === null || _b === void 0 ? void 0 : _b.y);
            line.endFill();
        }
        if (!_canAttack || _target === null || !_target.sprite || !sprite)
            return;
        // check if in range
        if (!(0, Colliders_1.isIntersectingRect)(sprite, _target.sprite, getStats().attackRange))
            return;
        if (_isRanged) {
            (0, Projectile_1.Projectile)({
                startPos: sprite,
                targetPos: _target.sprite,
                name: "arrow",
                viableTargets: _unitData.type === "enemy" ? __spreadArray([app_1.gameState.player], app_1.gameState.minions, true) : app_1.gameState.enemies,
                onCollide: function (target) { return (0, Attack_1.attackTarget)(getStats(), target); },
            });
        }
        else {
            (0, Attack_1.attackTarget)(getStats(), _target);
        }
        _canAttack = false;
        // TODO: check for potential memory leaks here
        gameTicks$
            .pipe((0, rxjs_1.take)(getStats().attackSpeed + 1), (0, rxjs_1.finalize)(function () { return _canAttack = true; })).subscribe();
    };
    var addItemToDrops = function (item) {
        if (!_dropTable.always) {
            _dropTable.always = [];
        }
        _dropTable.always.push(item);
    };
    var unit = {
        id: id,
        name: unitName,
        target: null,
        level: level, // TODO: encapsulate this?
        sprite: sprite,
        health: health,
        getStats: getStats, // TODO: fix "stats" definition so that player doesn't have to call this function...
        addToStat: addToStat,
        setStat: setStat,
        setTarget: setTarget,
        clearTarget: clearTarget,
        addItemToDrops: addItemToDrops,
    };
    // define public accessors
    Object.defineProperties(unit, {
        target: {
            get: function () { return _target; },
            enumerable: true,
        },
        stats: {
            get: getStats,
            enumerable: true,
        },
        targetType: {
            get: function () { return _targetTypes; },
            enumerable: true,
        },
        attackers: {
            get: function () { return _attackers; },
            enumerable: true,
        },
        itemsHeld: {
            get: function () { return _itemsHeld; },
            enumerable: true
        },
        isRanged: {
            get: function () { return _isRanged; },
            set: function (v) { return _isRanged = v; },
            enumerable: true,
        }
    });
    return unit;
};
exports.createUnit = createUnit;
